<template>
  <v-container
    class="bg bg--gray"
    fill-height
    fluid
  >
    <LoginBox>
      <div v-if="isSuccess">
        <Form
          v-if="form"
          :data="data"
          @toogleContainer="toogleContainer"
        />

        <Success v-if="success" :data="data" />
      </div>

      <v-layout
        v-else
        class="wrapper"
        justify-center
        align-center
        column
      >
        <div v-if="isFailed">
          <p>{{ $t('Common.genericError') }}</p>
          <a
            v-text="$t('Common.tryAgain') "
            class="accent--text"
            :title="$t('Common.tryAgain')"
            @click.prevent="getCompanyNameFirstAccess"
          />
        </div>

        <v-progress-circular
          v-if="isLoading"
          color="primary"
          indeterminate
        />
      </v-layout>
    </LoginBox>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import requestStatusMixin from 'mixins/requestStatus'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { isValidObject, catchError } from 'corp-front-vue-commons/src/utils/functions'
import Form from 'components/pages/firstAccess/Form'
import Success from 'components/pages/firstAccess/Success'

export default {
  name: 'FirstAccessPage',
  mixins: [requestStatusMixin],
  components: {
    Form,
    Success
  },
  computed: {
    routeParams () {
      const { employeeId = null, token = null } = this.$route.params
      const id = employeeId ? Number(employeeId) : null

      return {
        employeeId: id,
        token
      }
    }
  },
  data () {
    return {
      namespace: 'Views.FirstAccessPage',
      currentStatus: null,
      form: true,
      success: false,
      companyName: null,
      data: {}
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    redirectToLogin () {
      this.$router.push({ name: 'Login' }).catch(e => {})
    },

    isValidObject (val) {
      return isValidObject(val)
    },

    hasValidToken () {
      this.showAlert({
        type: 'info',
        message: this.$t(`${this.namespace}.form.invalidToken`),
        timeout: 8000
      })
    },

    toogleContainer (data) {
      this.form = false
      this.success = true

      if (this.isValidObject(data)) {
        this.data = {
          ...this.data,
          ...data
        }
      }
    },

    async getCompanyNameFirstAccess () {
      this.setStatus(STATUS_IS_LOADING)

      try {
        const { employeeId, token: firstAccessToken } = this.routeParams
        const { data: res } = await this.$apiService.employee.getCompanyNameFirstAccess(employeeId, {
          firstAccessToken
        })

        if (!res || res.status !== 'success') {
          throw new Error()
        }

        this.data = { ...res.data }
        this.setStatus(STATUS_SUCCESS)
      } catch (error) {
        catchError(error)

        if (error && error.response && error.response.status === 403) {
          this.hasValidToken()
          this.redirectToLogin()
          return
        }

        this.setStatus(STATUS_FAILED)
      }
    }
  },
  mounted () {
    this.getCompanyNameFirstAccess()
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  min-height: 300px;
  text-align: center;
}
</style>
